import { render, staticRenderFns } from "./UseGasTrend.vue?vue&type=template&id=10bcf799&scoped=true&"
import script from "./UseGasTrend.vue?vue&type=script&lang=js&"
export * from "./UseGasTrend.vue?vue&type=script&lang=js&"
import style0 from "./UseGasTrend.vue?vue&type=style&index=0&id=10bcf799&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcf799",
  null
  
)

export default component.exports